import React, { Component } from 'react';

import Cookies from 'js-cookie';

import { Redirect } from 'react-router';

import { AppShell } from './AppShell';

import { clearSession, hasStaleAuthCookie, isAuthenticated } from '../services/authService';

import { startSessionWatchdog, stopSessionWatchdog, handleStorageSync } from '../services/sessionService';



export class Layout extends Component {

    static displayName = Layout.name;



    constructor(props) {

        super(props);



        this.state = {

            auth: isAuthenticated()

        };

        this.onAuthenticated = this.onAuthenticated.bind(this);

    }



    onAuthenticated() {

        const authenticated = isAuthenticated();

        this.setState({ auth: authenticated });

        if (authenticated) {

            startSessionWatchdog();

        } else {

            stopSessionWatchdog();

            window.dispatchEvent(new CustomEvent('logout'));

        }

    }



    componentDidMount() {

        window.addEventListener('authenticated', this.onAuthenticated);

        window.addEventListener('storage', handleStorageSync);

        if (hasStaleAuthCookie()) {

            clearSession();

        } else if (isAuthenticated()) {

            startSessionWatchdog();

        }

    }



    componentWillUnmount() {

        window.removeEventListener('authenticated', this.onAuthenticated);

        window.removeEventListener('storage', handleStorageSync);

        stopSessionWatchdog();

    }



    render() {

        var alumnoCodigosRaw = Cookies.get('alumnoCodigos');



        var alumnoCodigos = alumnoCodigosRaw

            ? JSON.parse(alumnoCodigosRaw)

            : null;

        const isStaff = alumnoCodigos && alumnoCodigos.length === 1 && alumnoCodigos[0] === -1;



        return (

            <div>

                {this.state.auth ? (

                    <AppShell variant={isStaff ? 'admin' : 'student'}>

                        {this.props.children}

                    </AppShell>

                ) : (

                    <>

                        <Redirect to="/" />

                        {this.props.children}

                    </>

                )}

            </div>

        );

    }

}

